import React from 'react'
import ReactDOM from 'react-dom/client'

window.addEventListener('error', (event) => {
  alert('CRITICAL ERROR: ' + event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  alert('ASYNC ERROR: ' + event.reason);
});

import App from './App.tsx'
import './index.css'

class ErrorBoundary extends React.Component<{children: React.ReactNode}, {hasError: boolean, error: any}> {
  constructor(props: {children: React.ReactNode}) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return <div style={{padding: 40, color: 'white', background: 'red', zIndex: 9999, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}><h2>React Crash!</h2><pre>{this.state.error?.stack || this.state.error?.toString()}</pre></div>;
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)

// Unregister Service Workers & purge CacheStorage to prevent stale asset serving on Vercel
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
if (typeof window !== 'undefined' && 'caches' in window) {
  caches.keys().then((names) => {
    for (let name of names) caches.delete(name);
  });
}

